/**
 * ========================================================================
 * Auth0 Configuration
 * ========================================================================
 * 
 * This file contains Auth0-specific configuration.
 * Facebook permissions are imported from the centralized facebook.ts config.
 * 
 * See: ./facebook.ts for Facebook permissions configuration
 * ========================================================================
 */

import { FACEBOOK_PERMISSIONS } from "./facebook";

export const auth0Config = {
  domain:
    process.env.REACT_APP_AUTH0_DOMAIN || "dev-ngvu71k1epvkv42m.us.auth0.com",
  clientId:
    process.env.REACT_APP_AUTH0_CLIENT_ID || "DEmhdWN9hoM1ZgS4H2dtXecMIbWOWpw6",
  audience:
    process.env.REACT_APP_AUTH0_AUDIENCE || process.env.REACT_APP_BACKEND_URL,
  redirectUri: `${
    process.env.REACT_APP_FRONTEND_URL || window.location.origin
  }/callback`,
  logoutUri:
    process.env.REACT_APP_LOGOUT_URL ||
    `${process.env.REACT_APP_FRONTEND_URL || window.location.origin}/login`,
  scope: "openid profile email offline_access",
  // Social connection configurations
  socialConnections: {
    facebook: {
      name: "facebook",
      display_name: "Facebook",
      strategy: "facebook",
      options: {
        client_id: process.env.REACT_APP_FACEBOOK_CLIENT_ID,
        client_secret: process.env.REACT_APP_FACEBOOK_CLIENT_SECRET,
        scope: FACEBOOK_PERMISSIONS,
      },
    },
    instagram: {
      name: "instagram",
      display_name: "Instagram",
      strategy: "instagram",
      options: {
        client_id: process.env.REACT_APP_INSTAGRAM_CLIENT_ID,
        client_secret: process.env.REACT_APP_INSTAGRAM_CLIENT_SECRET,
        scope: ["user_profile", "user_media"],
      },
    },
    google: {
      name: "google-oauth2",
      display_name: "Google",
      strategy: "google-oauth2",
      options: {
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
        scope: ["openid", "profile", "email"],
      },
    },
  },
};

// Export login options for social providers
export const facebookLoginOptions = {
  authorizationParams: {
    connection: "facebook",
    scope:
      `openid profile email offline_access ${FACEBOOK_PERMISSIONS.join(" ")}`,
    audience: auth0Config.audience,
    redirect_uri: auth0Config.redirectUri,
  },
};

// Google sign-in. Credentials live in the Auth0 dashboard (Authentication →
// Social → Google); we only name the connection. audience/scope/redirect_uri
// are inherited from the Auth0Provider defaults.
export const googleLoginOptions = {
  authorizationParams: {
    connection: "google-oauth2",
  },
};

// Email + password via Auth0's default Database connection. Universal Login
// handles login, password reset, and email verification for this connection.
export const emailLoginOptions = {
  authorizationParams: {
    connection: "Username-Password-Authentication",
  },
};

// Same Database connection, but open Universal Login on the Sign Up tab.
export const emailSignupOptions = {
  authorizationParams: {
    connection: "Username-Password-Authentication",
    screen_hint: "signup",
  },
};
